"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Slider = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    input[type='range'] {\n        -webkit-appearance: none;\n        width: 100%;\n        height: 5px;\n        border-radius: 5px;\n        background: #444;\n        outline: none;\n        padding: 0;\n        margin: 0;\n    }\n    input[type='range']::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        appearance: none;\n        width: 14px;\n        height: 14px;\n        border-radius: 50%;\n        background: ", ";\n        cursor: pointer;\n        transition: background 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    }\n    input[type='range']::-webkit-slider-thumb:hover {\n        background: ", ";\n    }\n    input[type='range']:active::-webkit-slider-thumb {\n        background: ", ";\n    }\n    input[type='range']::-moz-range-thumb {\n        width: 14px;\n        height: 14px;\n        border: 0;\n        border-radius: 50%;\n        background: ", ";\n        cursor: pointer;\n        transition: background 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    }\n    input[type='range']::-moz-range-thumb:hover {\n        background: ", ";\n    }\n    input[type='range']:active::-moz-range-thumb {\n        background: ", ";\n    }\n    input[type='range']:focus::-webkit-slider-thumb {\n        box-shadow: 0 0 0 2px #444, 0 0 0 4px ", ";\n    }\n\n    ::-moz-range-track {\n        background: #444;\n        border: 0;\n    }\n\n    input::-moz-focus-inner,\n    input::-moz-focus-outer {\n        border: 0;\n    }\n"])), function (props) {
  return props.theme.admin.editor.text;
}, function (props) {
  return props.theme.admin.colors.brand;
}, function (props) {
  return props.theme.admin.colors.brand;
}, function (props) {
  return props.theme.admin.editor.text;
}, function (props) {
  return props.theme.admin.colors.brand;
}, function (props) {
  return props.theme.admin.colors.brand;
}, function (props) {
  return props.theme.admin.colors.brand;
});

exports.Slider = Slider;